export default __webpack_public_path__ + "static/media/steps.0b80fbfa.svg";